import React from "react";
import {DefaultLoader} from "../Partials/LoadingIndicator";

const initialState = {
}

export default class PleaseWait extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <p>Vielen Dank für die Nutzung des kostenlosen eRecht24 Scanners.
                    Bitte haben Sie etwas Geduld.
                    Wenn Sie Ihre E-Mail-Adresse bestätigt haben, sehen Sie hier gleich Ihr Scan-Ergebnis.
                </p>
                <div className="flex flex-row items-center mt-6">
                    <DefaultLoader></DefaultLoader>
                    <span className="lead-modal--loading-text ml-2">Ihr Scan-Ergebnis wird generiert.</span>
                </div>
            </div>
        )
    }
}
